import type { RioCategory } from '@backoffice-frontend/graphql'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { getCategoryConfig } from '../config'

export const getRioCategoryRights = (category: RioCategory) => {
  return getCategoryConfig(category).rights
}

export const useHasRioWriteRights = (category: RioCategory): boolean => {
  const { write } = getCategoryConfig(category).rights
  return useUserHasAccess({
    allowedRights: write,
  })
}

export const useHasRioReadRights = (category: RioCategory): boolean => {
  const { read } = getCategoryConfig(category).rights
  return useUserHasAccess({
    allowedRights: read,
  })
}
